import gql from 'graphql-tag';

export default gql`
mutation UpdateLease(
        $uuids: String!,
        $endpointsCompleted: Int!,
        $completed: Boolean
        ) {
    updateLease(input:{
        uuids: $uuids,
        endpointsCompleted: $endpointsCompleted,
        completed: $completed
    }) {
        __typename
        uuids
    }
}
`;
